<div class="page-content">
    <markdown [src]="'../../../assets/538-flipping/README.md'"></markdown>
</div>

<app-links-toolbar>
    <li><a href="https://github.com/azhu2/538-flipping" matTooltip="Github source"><img class="img-icon" src="../../../assets/github.svg" /></a></li>
</app-links-toolbar>